import CopyAllIcon from '@mui/icons-material/CopyAll';
import { useCopyToClipboard } from 'hooks/useCopyToClipboard';
import { useRecordContext } from 'react-admin';
import { IconButton } from 'shared/mui/IconButtons';
import { Stack } from 'shared/mui/Stack/Stack';
import { Tooltip } from 'shared/mui/Tooltip';
import { Typography } from 'shared/mui/Typography';
import { OrderLog } from 'types/embedded/orderLog';

type Props = {
  source: 'requestData' | 'responseData';
  label: string;
};
export const OrdersShowLogsExpandCopyButton: React.FC<Props> = ({ source, label }) => {
  const record = useRecordContext<OrderLog>();
  const { tooltipText, handleCopy } = useCopyToClipboard(JSON.stringify(record?.[source], null, 2));

  return (
    <Stack alignItems="center" direction="row" gap="8px">
      <Typography sx={{ fontWeight: 500 }} variant="body2">
        {label}
      </Typography>
      <Tooltip disableHoverListener open={!!tooltipText} title={tooltipText}>
        <IconButton onClick={handleCopy} size="small">
          <CopyAllIcon sx={{ fontSize: 'inherit' }} />
        </IconButton>
      </Tooltip>
    </Stack>
  );
};
